'use strict';
module.exports = 9007199254740991;



/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/max-safe-integer/index.js
 ** module id = 1073
 ** module chunks = 0
 **/